var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.isedit
        ? _vm.$t(
            "label_essweb_BlockLeaveMapping_form_property_dialog_editTitle"
          )
        : _vm.$t(
            "label_essweb_BlockLeaveMapping_form_property_dialog_newTitle"
          ),
      dialog: _vm.show,
      maxWidth: "680",
    },
    on: {
      close: function ($event) {
        _vm.show = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "white lighten-5",
                    attrs: { align: "center", justify: "start" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            label:
                              "label_essweb_BlockLeaveMapping_list_staffLabel",
                            disabled: _vm.isedit,
                            readonly: _vm.isedit,
                            chips: "",
                            avatar: "",
                            filter: _vm.$staffFilter,
                            "small-chips": "",
                            "two-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            items: _vm.allStaff,
                            "item-value": "staff_id",
                            "item-text": "preferred_name",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      left: "",
                                      small: "",
                                      contentClass: "white--text",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "selection",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.preferred_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "item.title",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("span", { staticClass: "text-body-2" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            data.item.preferred_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-caption-xs",
                                    },
                                    [_vm._v(_vm._s(data.item.staff_code))]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.subtitle",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.job_post_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.staff_uuid,
                            callback: function ($$v) {
                              _vm.staff_uuid = $$v
                            },
                            expression: "staff_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            label:
                              "label_essweb_BlockLeaveMapping_form_YearLabel",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            items: _vm.Years,
                            itemValue: "value",
                            itemText: "label",
                          },
                          model: {
                            value: _vm.year,
                            callback: function ($$v) {
                              _vm.year = $$v
                            },
                            expression: "year",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            label: "label_essweb_BlockLeavePolicy_list_title",
                            items: _vm.allGroup,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            itemValue: "uuid",
                            itemText: "block_leave_group_name",
                          },
                          model: {
                            value: _vm.group_uuid,
                            callback: function ($$v) {
                              _vm.group_uuid = $$v
                            },
                            expression: "group_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: {
                save: _vm.toSave,
                cancel: function ($event) {
                  _vm.show = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }